// @flow

import React from 'react';
import CrossSellGaugeElement from './CrossSellGaugeElement';

type Props = {
  crossSellPercentage: number,
}

function CrossSellGauge({ crossSellPercentage }: Props) {
  const echelonNumber: number = 10;
  const maxPercentage = 20;
  const isPassed = (echelon: number) =>
    ((echelon * echelonNumber) / ((100 * 100) / maxPercentage)) <= crossSellPercentage;
  return (
    <div className="cross-sell-gauge">
      {
        Array.from(Array(echelonNumber))
          .map((_, index) => (
            <CrossSellGaugeElement key={index.toString()} isPassed={isPassed(index)} />
          ))
      }
    </div>
  );
}

export default CrossSellGauge;
